<template>
    <div
        v-if="
            useInfluencerAddButtonRoute.indexOf(route.name) !== -1
            && getUserTopRole() === 'influencer'
        "
        class="w-full mx-auto w-full fixed right-0 bottom-[84px] flex justify-center"
    >
        <div
            class="flex flex-col items-end justify-center gap-10 pc-max-width w-full pr-20"
        >
            <transition
                enter-active-class="transition-transform duration-500 ease-in-out"
                enter-from-class="opacity-0 -translate-y-5"
                enter-to-class="opacity-100 translate-y-0"
                leave-active-class="transition-transform duration-500 ease-in-out"
                leave-from-class="opacity-100 translate-y-0"
                leave-to-class="opacity-0 -translate-y-5"
            >
                <div v-if="isActive" class="flex flex-col bg-white rounded-10 cursor-pointer shadow-shadow">
                    <div
                        class="p-6 pr-12 flex gap-5 items-center justify-between"
                        @click="() => {
                            isActive = false;
                            router.push({ name: 'influencer-feed-upload' });
                        }"
                    >
                        <div class="w-[36px] h-[36px] flex items-center justify-center">
                            <icon-camera2 />
                        </div>
                        <p class="text-14 text-gray4 font-medium">{{ t('feed.upload') }}</p>
                    </div>
                    <div
                        class="p-6 pr-12 flex gap-5 items-center justify-center"
                        @click="() => {
                            isActive = false;
                            router.push({ name: 'product-custom' });
                        }"
                    >
                        <icon-clothes active="true" fill="#505050"/>
                        <p class="text-14 text-gray4 font-medium">{{ t('custom.customization') }}</p>
                    </div>
                </div>
            </transition>
            <div class="rounded-100 bg-gray4 w-[48px] h-[48px] flex items-center justify-center cursor-pointer">
                <icon-cancel2 v-if="isActive" @click="isActive = !isActive" />
                <icon-plus v-else @click="isActive = !isActive" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
// i18n
const { locale, t } = useI18n();

// route
const router = useRouter();
const route = useRoute();

// store
const userStore = useUserStore();

// const
const useInfluencerAddButtonRoute = ['main', 'my_page'];

// data
const isActive = ref(false);

watch(() => route.name, () => {
    isActive.value = false;
});

</script>
